export default __webpack_public_path__ + "static/media/fourthOne.d90d12bb.png";